import { FloatingTooltip } from '../../Floating'
import { IconNG } from '../IconNG'

function IconWithTooltip({
  isTooltipOpenOnClick,
  ref,
  tooltip,
  tooltipPlacement,
  ...restProps
}) {
  return (
    <FloatingTooltip
      content={tooltip}
      isOpenOnClick={isTooltipOpenOnClick}
      placement={tooltipPlacement}
    >
      <IconNG {...restProps} ref={ref} />
    </FloatingTooltip>
  )
}

export default IconWithTooltip
